module.exports = __webpack_public_path__ + "res/20-img_game_bg_l.03c9b74e17003fbbd12744219f9cdb92.png";